import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const layout = {
  namespaced: true,
  state: {
    config: {},
    defaultPage: {},
    theme: {},
    header: {},
    menu: {},
    breadcrumbs: {},
    sidebar: {},
    loading: {},
    footer: {},
    login: {},
    dialogs: {},
    expiredMessage: null,
    form: {}
  },
  getters,
  mutations,
  actions
};
